<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
      :disabled="!programId"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Session
    </button>

    <a-modal v-model="visible" title="Add New Tuition Session" :footer="null">
      <a-form :form="form" @submit="handleSubmit">
        <div class="row">
          <div class="col-md-8 col-12">
            <a-form-item label="Session Name">
              <a-input
                placeholder="e.g. Morning Batch"
                v-decorator="['name', { rules: [{ required: true, message: 'Please enter session name' }] }]"
              />
            </a-form-item>
          </div>
          <div class="col-md-4 col-12">
            <a-form-item label="Code">
              <a-input
                placeholder="e.g. MORN"
                v-decorator="['code', { rules: [{ required: true, message: 'Please enter code' }] }]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-12">
            <a-form-item label="Default Start Time">
              <a-time-picker
                format="HH:mm"
                style="width: 100%"
                v-decorator="['default_start_time', { rules: [{ required: true, message: 'Please select start time' }] }]"
              />
            </a-form-item>
          </div>
          <div class="col-md-6 col-12">
            <a-form-item label="Default End Time">
              <a-time-picker
                format="HH:mm"
                style="width: 100%"
                v-decorator="['default_end_time', { rules: [{ required: true, message: 'Please select end time' }] }]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-12">
            <a-form-item label="Status">
              <a-select v-decorator="['status', { initialValue: 1 }]">
                <a-select-option :value="1">Active</a-select-option>
                <a-select-option :value="0">Inactive</a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="text-right mt-4">
          <a-button class="mr-2" @click="handleCancel">Cancel</a-button>
          <a-button type="primary" html-type="submit" :loading="loading">Save Session</a-button>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AddTuitionSessionModal',
  props: {
    programId: {
      type: [Number, String],
      required: false,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      if (!this.programId) {
        this.$message.warning('Please select a program first.')
        return
      }
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          const payload = {
            ...values,
            default_start_time: values.default_start_time.format('HH:mm'),
            default_end_time: values.default_end_time.format('HH:mm'),
          }

          this.$http.post(`/api/tuition/programs/${this.programId}/sessions`, payload)
            .then(() => {
              this.loading = false
              this.visible = false
              this.$emit('created')
              this.form.resetFields()
              this.$notification.success({
                message: 'Success',
                description: 'Tuition session created successfully.',
              })
            })
            .catch(error => {
              this.loading = false
              this.$neoNotify.error(error)
            })
        }
      })
    },
  },
}
</script>
